import { number } from 'prop-types';


export class CoolEmailSettings {    
        
    to: string = '';
    subject: string = '';
    body: string = '';
}
